/* eslint-disable no-console */
import { register } from 'register-service-worker';
import MailServices from '@/idb/MailServices';

// const condition = [ 'production', 'development' ].includes( process.env.NODE_ENV );
const condition = process.env.NODE_ENV === 'production';
if ( condition ) {
    register( `${ process.env.BASE_URL }service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n'
        + 'For more details, visit https://goo.gl/AFskqB',
            );
        },
        registered() {
            // console.log( 'Service worker has been registered.' );
            MailServices.standupDatabase();
        },
        cached() {
            // console.log( 'Content has been cached for offline use.' );
        },
        updatefound() {
            // console.log( 'New content is downloading.' );
        },
        updated() {
            // console.log( 'New content is available; please refresh.' );
        },
        offline() {
            // console.log( 'No internet connection found. App is running in offline mode.' );
        },
        // eslint-disable-next-line no-unused-vars
        error( error ) {
            // console.error( 'Error during service worker registration:', error );
        },
    } );
}
